/**
 * Parses minified React production errors (e.g. "Minified React error #185").
 * Decoded text is loaded on demand via `react17ProductionErrorCodesLoader` (dynamic import).
 */
const MINIFIED_REACT_PATTERN = /Minified React error #(\d+)/;
export function parseMinifiedReactInvariant(message: string): number | null {
  if (!message) return null;
  const match = message.match(MINIFIED_REACT_PATTERN);
  if (!match) return null;
  const code = Number.parseInt(match[1], 10);
  return Number.isFinite(code) ? code : null;
}